import { createSlice } from '@reduxjs/toolkit';
import { createSelector } from 'reselect';

export const initialState = {
    appMessageColors: [
      { text: 'Default', value: '#faa307' },
      { text: 'Purple', value: '#872F8C' },
      { text: 'Red', value: '#EA3F24' },
      { text: 'Green', value: '#A2CF6E' },
      { text: 'DarkGrey', value: '#919191' },
    ],
    processingItems: { loading: true, data:{} },
    processingHomes: [],
    processingHomesIsLoading: false,
    appMessages: [],
    maintenanceMode: false,
    currentAppVersion: null,
    selectedAdminTab: 'appMessages'
}

// create slice will call createAction and createReducer for us internally
const slice = createSlice({
  name: 'adminSlice',
  initialState,
  reducers: {
    updateAppMessages: (state, action) => {
      state.appMessages = action.payload;
    },
    clientSwitchMaintenanceMode: (state, action) => { // Clients react on fact that maintenance mode has changed and show maintenance screen in their own browsers
      state.maintenanceMode = action.payload;
    },
    setCurrentAppVersion: (state, action) => {
      state.currentAppVersion = action.payload;
    },
    setSelectedAdminTab: (state, action) => {
      state.selectedAdminTab = action.payload;
    },
    setProcessingItems: (state, action) => {
      state.processingItems = action.payload;
    },
    setProcessingHomes: (state, action) => {
      state.processingHomes = action.payload;
    },
    setProcessingHomesIsLoading: (state, action) => {
      state.processingHomesIsLoading = action.payload;
    },
    // Redux saga actions, no reducers
    fetchAppMessages: () => { }, // Triggers getAppMessageSaga
    deleteAppMessage: () => { }, // Triggers deleteAppMessageSaga
    createAppMessage: () => { }, // Triggers createAppMessageSaga
    updateAppMessage: () => { }, // Triggers updateAppMessageSaga
    checkVersionForMaintenance: () => { }, // Triggers versionCheckForMaintenanceSaga
    adminSwitchMaintenanceMode: () => { }, // Triggers maintenanceSaga. Admin triggers the release button, and all users recieve notification
    processingItemsService: () => { }, // Triggers getProcessingItemsSaga
    fetchProcessingHomes: () => { } // Triggers getProcessingItemsSaga
  }
});
export default slice.reducer;

export const adminActions = slice.actions;

export const adminSelectors = {
  mainAppMessageSelector: createSelector(
    state => state.adminState.appMessages,
    appMessages => appMessages.find(msg => msg.isMain === true)
  ),
  processingItemsServiceStatusSelector: createSelector(
    state => state.adminState.processingItems,
    processingItems => processingItems
  ),
}
